import styled from 'styled-components'

export const LoginFormContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100vh;
    width: 90%;
    max-width: 1110px;
    margin: auto;
    @media screen and (min-width: 992px) {
        display: row;
        justify-content: space-between;
    }
`
export const FormContainer = styled.form`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px;
    border-radius: 8px;
    width: 100%;
    max-width: 350px;
    @media screen and (min-width: 992px) {
        width: 350px;
        flex-shrink: 0;
        box-shadow: 0px 8px 40px rgba(7, 7, 7, 0.68);
        padding: 64px 48px 64px 48px;
    }
`
export const LoginWebsiteLogo = styled.img`
    width: 185px;
`
export const InputContainer = styled.div`
    display: flex;
    flex-direction: column;
    margin-top: 20px;
    width: 100%;
`
export const InputLabel = styled.label`
    margin-bottom: 0px;
    font-family: 'Roboto', sans-serif;
    font-weight: bold;
    font-size: 12px;
    line-height: 16px;
    color: #475569;
`
export const UserNameInputFiled = styled.input`
    font-size: 14px;
    height: 40px;
    border: 1px solid #d7dfe9;
    background-color: #e2e8f0;
    color: #64748b;
    border-radius: 2px;
    margin-top: 5px;
    padding: 8px 16px 8px 16px;
    outline: none;
`
export const PasswordInputFiled = styled.input`
    font-size: 14px;
    height: 40px;
    border: 1px solid #d7dfe9;
    background-color: #e2e8f0;
    color: #64748b;
    border-radius: 2px;
    margin-top: 5px;
    padding: 8px 16px 8px 16px;
    outline: none;
`
export const ShowHideContainer = styled.div`
    display: flex;
    margin-top: 10px;
`
export const CheckBoxInput = styled.input`
    margin-right: 4px;
`
export const LoginButton = styled.button`
    color: #ffffff;
    font-family: 'Roboto', sans-serif;
    background-color: #3b82f6;
    border-radius: 5px;
    border:none;
    font-weight:bold;
    height:40px;
    font-size:14px;
    width:100%;
    margin-top:20px;
    margin-bottom:2px;
    outline:none;
    cursor:pointer;
`
export const ErrorMessage = styled.p`
    align-self:start;
    font-size:12px;
    margin-top:3px;
    margin-bottom:0px;
    font-family:'Roboto;
    font-size:12px;
    line-height:16px;
    color:#ff0b37;
`
